export const STOCKTAKING_STATUS = {
  IN_PROGRESS: 'in_progress',
  ADJUSTED: 'adjusted',
  COMPLETED: 'completed',
  ABORTED: 'aborted',
};

export const STOCKTAKING_STATUS_OPTIONS = [
  { key: 'in_progress', value: 'in_progress', label: 'In Progress' },
  { key: 'adjusted', value: 'adjusted', label: 'Adjusted' },
  { key: 'completed', value: 'completed', label: 'Completed' },
  { key: 'aborted', value: 'aborted', label: 'Aborted' },
];

export const STOCKTAKING_STATUS_LABEL = {
  in_progress: 'In Progress',
  adjusted: 'Adjusted',
  completed: 'Completed',
  aborted: 'Aborted',
};

export const getStocktakingBadgeColor = status => {
  switch (status) {
    case 'in_progress':
      return 'primary';
    case 'adjusted':
      return 'warning';
    case 'completed':
      return 'success';
    case 'aborted':
      return 'secondary';
    default:
      return 'secondary';
  }
};

export const STOCKTAKING_SCOPE = {
  FULL: 'full',
  PARTIAL: 'partial',
};

export const STOCKTAKING_SCOPE_LABEL = {
  full: 'Full',
  partial: 'Partial',
};

export const getScopeBadgeColor = scope => {
  switch (scope) {
    case 'full':
      return 'info';
    case 'partial':
      return 'light';
    default:
      return 'secondary';
  }
};
